import React from 'react';
import { DefaultSpinner } from 'components';

const Spinner = () => (
  <DefaultSpinner />
);

const spinnerWhileLoading = hasLoaded => WrappedComponent => (props) => {
  if (!hasLoaded(props)) {
    return <Spinner />;
  }

  return <WrappedComponent {...props} />;
};

export default spinnerWhileLoading;
